import fetchAPI from '../../../lib/utils/fetch-api'
import { setTimelineLoading, setTimelineFailed, setTimelineData } from './actions'
import { EntityType } from '../../shared/types/EntityType'

const activeRequests = new Map<string, Promise<any>>()

export function getTimeLineData(entityType: EntityType, entityId: string | number) {
  return async dispatch => {
    const requestKey = `${entityType}_${entityId}`

    const existingRequest = activeRequests.get(requestKey)
    if (existingRequest) {
      return existingRequest
    }

    const requestPromise = (async () => {
      dispatch(setTimelineLoading())
      try {
        const response = await fetchAPI(`/api/get-activity/${entityType}/${entityId}`)
        if (response['errors']) {
          let error = response['errors']
          if (Array.isArray(error)) {
            error = error.join()
          }
          dispatch(setTimelineFailed(error))
          return
        }

        if (response['items']) {
          const formattedItems = response['items']?.map(item => ({
            ...item,
            date: String(item.date),
            items: Array.isArray(item.items)
              ? item.items.map(activityItem => ({
                  ...activityItem,
                  date: String(activityItem.date),
                }))
              : [],
          }))

          response['items'] = formattedItems
          response['itemsDates'] = formattedItems?.map(itemsByDays => String(itemsByDays.date))
        }
        dispatch(setTimelineData(response))
      } catch (err) {
        dispatch(setTimelineFailed(err as string))
      } finally {
        activeRequests.delete(requestKey)
      }
    })()

    activeRequests.set(requestKey, requestPromise)
    return requestPromise
  }
}

// Отдельный action creator для загрузки только файлов (оптимизированная версия для вкладки "Прикрепленные файлы")
export function getTimeLineFiles(entityType: EntityType, entityId: string | number) {
  return async dispatch => {
    const requestKey = `${entityType}_${entityId}_files`

    const existingRequest = activeRequests.get(requestKey)
    if (existingRequest) {
      return existingRequest
    }

    const requestPromise = (async () => {
      dispatch(setTimelineLoading())
      try {
        const response = (await fetchAPI(`/api/get-activity/${entityType}/${entityId}`)) || []

        if (response['errors']) {
          let error = response['errors']
          if (Array.isArray(error)) {
            error = error.join()
          }
          dispatch(setTimelineFailed(error))
          return
        }

        if (response['items']) {
          const filteredItems = response['items']
            ?.map(activityItems => {
              const files = activityItems?.items?.filter(
                activityItem => activityItem.type === 'file',
              )
              return files?.length ? { ...activityItems, items: files } : null
            })
            .filter(item => item !== null)

          if (filteredItems && filteredItems.length > 0) {
            const filteredResponse = {
              ...response,
              items: filteredItems,
              itemsDates: filteredItems?.map(itemsByDays => itemsByDays.date),
            }
            dispatch(setTimelineData(filteredResponse))
            return
          } else {
            return
          }
        }
      } catch (err) {
        dispatch(setTimelineFailed(err as string))
      } finally {
        activeRequests.delete(requestKey)
      }
    })()

    activeRequests.set(requestKey, requestPromise)
    return requestPromise
  }
}
